import { DatePipe, NgClass } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonInfoTooltipComponent } from '../common-component-info-tooltip/common-component-info-tooltip.component';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { MatTooltip } from '@angular/material/tooltip';
import { OtaInfoComponent } from '../ota-info/ota-info.component';
import { IndianNumberPipe } from '../pipes/indian-number.pipe';
import { otaBatchKpiInfo } from './ota-batch-view.info';
@Component({
  selector: 'app-ota-batch-view',
  templateUrl: './ota-batch-view.component.html',
  styleUrls: ['./ota-batch-view.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    NgClass,
    NgxPaginationModule,
    DatePipe,
    MatIcon,
    CommonSearchComponent,
    CommonPaginationComponent,
    MatTooltip,
    IndianNumberPipe,
    CommonInfoTooltipComponent,
    OtaInfoComponent,
  ],
})
export class OtaBatchViewComponent implements OnInit {
  OtaBatchId = '';
  OtaBatchName = '';
  OtaBatchDescription = '';
  OtaBatchDate = '';

  page = 1;
  size = 10;
  searchField = '';
  totalLength = 0;
  otaCommandList = [];
  deviceList = [];

  kpiSelected = 'All';
  totalAborted = 0;
  totalCompleted = 0;
  totalInProgress = 0;
  totalUploaded = 0;

  // Plain-language explanations shown by the info-tooltip icons on each KPI
  // card, kept in their own file (imported above) for isolation from this
  // component's logic.
  kpiInfo = otaBatchKpiInfo;

  batchRefId = '';

  deviceOTAForm: FormGroup = this.formBuilder.group({});

  userPermission = [];
  deleteOta = false;
  viewOta = false;

  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setOtaBatchForm();
    if (this.viewOta) {
      if (this.route.snapshot.paramMap.get('otaRefId')) {
        this.batchRefId = this.route.snapshot.paramMap.get('otaRefId') || '';
      }
      this.fetchBatchListSingle();
    }
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (element.pageName === 'OTA Batch' && element.view === false) {
          this.navigateBack();
        }
        if (element.pageName === 'OTA Batch' && element.view === true) {
          this.viewOta = true;
        }
        if (element.pageName === 'OTA Batch' && element.delete === true) {
          this.deleteOta = true;
        }
      }
    );
  }

  setOtaBatchForm() {
    this.deviceOTAForm = this.formBuilder.group({
      batchListSearch: new FormControl(''),
      batchDetailsSearch: new FormControl(''),
    });
  }

  fetchBatchListSingle() {
    this.spinner.show();
    this.otaCommandList = [];
    this.apiMicroservice
      .getBatchDataSingle(
        this.page,
        this.size,
        this.searchField,
        this.batchRefId,
        this.kpiSelected
      )
      .subscribe((res) => {
        this.spinner.hide();
        this.otaCommandList = [];
        if (res.status) {
          this.batchRefId = res.batchData._id;
          this.OtaBatchId = res.batchData.batchId;
          this.OtaBatchName = res.batchData.name;
          this.OtaBatchDescription = res.batchData.description;
          this.OtaBatchDate = new Date(res.batchData.createdAt).toLocaleString(
            'en-GB',
            {
              timeZone: 'Asia/Kolkata',
              hour12: true,
            }
          );
          this.deviceList = res.data.batchDeviceData;
          this.totalLength = res.data.totalItems;
          this.totalUploaded = res.totalUploaded;
          this.totalInProgress = res.totalInProgress;
          this.totalCompleted = res.totalCompleted;
          this.totalAborted = res.totalAborted;
        } else {
          this.apiMicroservice.openSnackbar('Something went wrong');
        }
      });
  }

  changeKPISelected(kpiSelected: string) {
    this.kpiSelected = kpiSelected;
    this.page = 1;
    this.searchField = this.deviceOTAForm?.get('batchDetailsSearch')?.value;
    this.fetchBatchListSingle();
  }

  onPageChange(event: number) {
    this.page = event;
    this.fetchBatchListSingle();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
    this.fetchBatchListSingle();
  }

  onSearch(event: string) {
    this.page = 1;
    this.searchField = event;
    this.deviceOTAForm?.get('batchDetailsSearch')?.setValue(event);
    this.fetchBatchListSingle();
  }

  navigateBack() {
    this.apiMicroservice.back();
  }

  deleteOtaBatchDetails(id: string) {
    if (confirm('Are you sure to Abort the device OTA?')) {
      const abortedBy = this.apiMicroservice.decryptData(
        sessionStorage.getItem('userRefId') || ''
      );
      this.apiMicroservice.deleteOtaBatchDevice(id, abortedBy).subscribe(
        (res) => {
          if (res.status) {
            this.apiMicroservice.openSnackbar('Device Aborted Successfully');
            this.ngOnInit();
          }
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          const example = ERROR.error.message;
          this.apiMicroservice.openSnackbar(example);
          this.ngOnInit();
        }
      );
    }
  }
}
